<template>
  <div class="section center">
    <div class="container-nuvem">
      <img class="info-imagem" src="@/assets/images/nuvem-info.png" />
      <img class="virus-imagem" src="@/assets/images/nuvem-virus.png" />
      <div
        v-for="(noticia, index) in noticias1"
        :key="noticia.classe"
        class="item"
        :class="noticia.classe"
        @click="openNoticias(index)"
      >
        {{ noticia.palavra }}
      </div>
    </div>
    <PopUpNoticias
      :isShowed="showNoticias"
      :noticias="noticias1"
      :index="indexNoticias"
      v-if="showNoticias"
      :show-proximo="false"
      @close="closeNoticias"
    ></PopUpNoticias>
    <div class="click-lelas mt-4">
      <i class="bi bi-hand-index mr-3"></i>
      Clique nas palavras para descobrir as manchetes.
    </div>
  </div>
</template>

<script>
import PopUpNoticias from "@/components/PopUpNoticias";
import { noticias1 } from "@/consts/noticias.js";
export default {
  components: {
    PopUpNoticias,
  },
  data() {
    return {
      showNoticias: false,
      noticias1,
      indexNoticias: 0,
    };
  },
  methods: {
    openNoticias(index) {
      this.indexNoticias = index;
      this.showNoticias = true;
    },
    closeNoticias() {
      this.showNoticias = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}

.click-lelas {
  font-family: Roboto Condensed;
  font-size: 14px;
  line-height: 16px;
  color: #626262;
}

.container-nuvem {
  position: relative;
  width: 615px;
  height: 590px;

  .item {
    text-transform: uppercase;
    position: absolute;
    font-family: Roboto Condensed;
    color: #626262;
    font-size: 32px;
    line-height: 38px;
    position: absolute;
    font-style: normal;
    font-weight: normal;
    transform-origin: top left;
    cursor: pointer;
    white-space: nowrap;
  }

  .temor {
    position: absolute;
    width: 93px;
    height: 38px;
    left: 8px;
    top: 0px;
    font-size: 32px;
    line-height: 38px;
  }

  .menor-periculosidade {
    position: absolute;
    width: 327px;
    height: 38px;
    left: 120px;
    top: 0px;
  }
  .menor-periculosidade-2 {
    width: 327px;
    height: 38px;
    left: 54px;
    top: 414px;
    font-size: 32px;
    line-height: 38px;
    transform: rotate(-90deg);
  }
  .menor-periculosidade-3 {
    width: 327px;
    height: 38px;
    left: 93px;
    top: 485px;
    font-size: 32px;
    line-height: 38px;

    transform: rotate(-90deg);
  }

  .moro {
    width: 80px;
    height: 38px;
    left: 459px;
    top: 0px;
  }

  .coronavirus-nao-e-habeas-corpus {
    width: 525px;
    height: 38px;
    left: 0px;
    top: 552px;
    transform: rotate(-90deg);
  }

  .coronavirus-nao-e-habeas-corpus-2 {
    width: 425px;
    height: 30px;
    left: 129px;
    top: 287px;
    font-size: 26px;
    line-height: 30px;
  }

  .conselho-nacional-de-justica {
    width: 460px;
    height: 38px;
    left: 54px;
    top: 47px;
  }

  .conselho-nacional-de-justica-2 {
    width: 424px;
    height: 33px;
    left: 136px;
    top: 453px;
    font-size: 28px;
    line-height: 33px;
  }

  .fux {
    width: 58px;
    height: 42px;
    left: 513px;
    top: 47px;
  }

  .prisao-domiciliar {
    width: 260px;
    height: 38px;
    left: 101px;
    top: 85px;
  }

  .moderacao {
    width: 190px;
    height: 42px;
    left: 370px;
    top: 85px;
    font-size: 36px;
    line-height: 42px;
  }

  .negou-soltura {
    width: 217px;
    height: 38px;
    left: 101px;
    top: 119px;
  }

  .lewandowski {
    width: 204px;
    height: 39px;
    left: 332px;
    top: 119px;
    font-size: 33px;
    line-height: 39px;
  }

  .populacao {
    width: 163px;
    height: 38px;
    left: 54px;
    top: 586px;
    transform: rotate(-90deg);
  }

  .stf-derruba {
    width: 134px;
    height: 28px;
    left: 514px;
    top: 287px;
    font-size: 24px;
    line-height: 28px;
    transform: rotate(-90deg);
  }

  .stf-derruba-2 {
    width: 179px;
    height: 38px;
    left: 93px;
    top: 482px;
    font-size: 32px;
    line-height: 38px;
  }

  .moderacao-2 {
    width: 169px;
    height: 38px;
    left: 277px;
    top: 482px;
    font-size: 32px;
    line-height: 38px;
  }

  .moro-3 {
    width: 80px;
    height: 38px;
    left: 450px;
    top: 482px;
    font-size: 32px;
    line-height: 38px;
  }

  .lewandowski-2 {
    width: 198px;
    height: 38px;
    left: 93px;
    top: 518px;
    font-size: 32px;
    line-height: 38px;
  }

  .assustou {
    width: 140px;
    height: 38px;
    left: 312px;
    top: 518px;
    font-size: 32px;
    line-height: 38px;
  }

  .fux-2 {
    width: 52px;
    height: 38px;
    left: 478px;
    top: 518px;
  }

  .coronavirus-nao-e-habeas-corpus-3 {
    width: 506px;
    height: 38px;
    left: 101px;
    top: 552px;
  }

  .liberdade-provisoria {
    width: 311px;
    height: 38px;
    left: 539px;
    top: 542px;
    transform: rotate(-90deg);
  }

  .conselho-nacional-de-justica-3 {
    width: 478px;
    height: 40px;
    left: 575px;
    top: 543px;
    font-size: 34px;
    line-height: 40px;
    transform: rotate(-90deg);
  }

  .moro2 {
    width: 80px;
    height: 38px;
    left: 539px;
    top: 212px;
    transform: rotate(-90deg);
  }

  .info-imagem {
    position: absolute;
    width: 372px;
    left: 128px;
    top: 128px;
  }

  .virus-imagem {
    position: absolute;
    width: 403px;
    left: 128px;
    top: 294px;
  }
}

@media screen and (max-width: 480px) {
  .container-nuvem {
    transform: scale(0.4);
  }
}
</style>